export default "__VITE_ASSET__b3ZrNpQN__"